import { Logo } from "@do/ui/components/logo";
import { cn } from "@do/ui/lib/utils";
import { useTranslations } from "next-intl";

export const FooterPoweredBy = () => {
  const t = useTranslations("do-chat-v2");

  return (
    <div
      id="footer-powered-by"
      aria-hidden="true"
      className={cn(
        "shrink-0 flex items-center justify-center overflow-hidden",
        "h-(--footer-powered-by-height)"
      )}
    >
      <a
        id="footer-powered-by-link"
        href="https://dialonce.ai"
        target="_blank"
        rel="noreferrer"
        tabIndex={-1}
        title={t("chat.footer.powered-by-dialonce")}
        className={cn(
          "text-center flex items-center justify-center gap-(--footer-powered-by-gap)",
          "text-(--footer-powered-by-color)/(--footer-powered-by-color-opacity)",
          "text-(length:--footer-powered-by-font-size)",
          "font-(--footer-powered-by-font-weight)! font-(family-name:--footer-powered-by-font-family)",
          "opacity-(--footer-powered-by-opacity) hover:opacity-(--footer-powered-by-hover-opacity)",
          "grayscale-100 hover:grayscale-0",
          "transition-all duration-300 ease-in-out"
        )}
      >
        <span id="footer-powered-by-text">{t("chat.footer.powered-by")}</span>
        <Logo
          id="footer-powered-by-logo"
          focusable="false"
          className="size-(--footer-powered-by-logo-height) pb-px"
        />
      </a>
    </div>
  );
};
